import md5 from 'md5';
import qs from 'qs';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * @funtion 排序数组对象
 * @param arr 需要排序的数组对象
 * @param key 以什么字段排序
 */
var sortArrayObj = function (arr, key) {
    return arr.sort(function (a, b) {
        var k1 = a[key];
        var k2 = b[key];
        if (k1 < k2) {
            return -1;
        }
        else if (k1 > k2) {
            return 1;
        }
        else {
            return 0;
        }
    });
};
/**
 * @function 获取Header
 * @param header
 * @param defaultHeader
 * @returns
 */
var getHeader = function (header, defaultHeader) {
    return header && typeof header === 'object'
        ? Object.assign({}, defaultHeader, header)
        : defaultHeader;
};
/**
 * @func 获取请求标识位名称 防止重复请求
 */
function getRequestName(reqOptions, reqData) {
    return "".concat(reqOptions.url, "&").concat(reqOptions.method, "&").concat(typeof reqData === 'string' ? reqData : JSON.stringify(reqData));
}
/**
 * @function 判断函数有存在
 * @param val
 * @returns
 */
function isFunction(f) {
    return f && toString.call(f) === '[object Function]';
}
/**
 * @function 处理自定义函数
 */
function handleCustomFn(fn) {
    var ext = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        ext[_i - 1] = arguments[_i];
    }
    if (fn && isFunction(fn)) {
        fn.apply(void 0, ext);
    }
}

var REPEAT_REQUEST = 'REPEAT REQUEST';
/**
 * @constant
 */
var ErrorType = {
    status: 1,
    reject: 2 // 请求失败
};
/**
 * @constant 默认的加签名参数
 */
var DEFAULT_SIGN = {
    appid: 'MINA-APPID',
    method: '',
    salt: 'xxxxxx',
    version: '1.0.0'
};
/**
 * @constant 'Content-Type'类型
 */
var FORMAT_TYPE = {
    json: { 'Content-Type': 'application/json;charset=UTF-8' },
    formdata: { 'Content-Type': 'multipart/formdata;charset=UTF-8' },
    urlencoded: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' }
};

var HttpService = /** @class */ (function () {
    /**
     * 构造函数
     * @param signParams 加签名参数
     */
    function HttpService(signParams) {
        this.failTimes = 0; // 接口请求失败次数（404/502等失误）
        /**
         * @property 加盐密钥
         */
        this.signParams = __assign({}, DEFAULT_SIGN);
        /**
         * @property 默认头部请求
         */
        this.defaultHeader = FORMAT_TYPE.urlencoded;
        /**
         * @property mock地址
         */
        this.mockUrl = '';
        /**
         * @property 超时时间,单位ms
         */
        this.timeout = 10000;
        /**
         * @property 是否启用防重复点击
         */
        this.needInterceptor = true;
        /**
         * @property 校验参数需删除的参数名
         */
        this.deleteKeyName = 'salt';
        /**
         * @property 切换域名列表
         */
        this.requerySite = [];
        /**
         * @function 是否允许切换域名
         * @param {boolean} switchGateway
         */
        this.switchGateway = true;
        // 用来取消请求 web端
        this.requestCancelMap = {};
        // 设置签名参数
        signParams && this.setSignParams(signParams);
    }
    /**
     * @funcution 清除重复请求
     * @param {reqOptions} reqOptions 请求参数
     * @param {reqData} reqData 处理后的请求参数
     * */
    HttpService.prototype.clearInterceptor = function (reqOptions, reqData) {
        if (this.needInterceptor) {
            this.requestCancelMap[getRequestName(reqOptions, reqData)] = false;
        }
    };
    /**
     * @function 设置加盐密钥
     * @param {ISignConfig} signParams
     */
    HttpService.prototype.setSignParams = function (signParams) {
        this.signParams = __assign({}, signParams);
    };
    /**
     * @function 设置默认头部请求
     * @param {string} formatType
     */
    HttpService.prototype.setDefaultHeader = function (formatType) {
        this.defaultHeader = FORMAT_TYPE["".concat(formatType)]
            ? FORMAT_TYPE["".concat(formatType)]
            : FORMAT_TYPE.urlencoded;
    };
    /**
     * @function 设置设置mock地址
     * @param {string} mockUrl
     */
    HttpService.prototype.setMockUrl = function (mockUrl) {
        this.mockUrl = mockUrl;
    };
    /**
     * @function 设置超时时间
     * @param {number} timeout
     */
    HttpService.prototype.setTimeout = function (timeout) {
        this.timeout = timeout;
    };
    /**
     * @function 兼容处理
     * @param timeout
     */
    HttpService.prototype.setAxiosTimeout = function (timeout) {
        this.timeout = timeout;
        console.warn('setAxiosTimeout已废弃，使用setTimeout替代');
    };
    /**
     * @function 设置是否启用防重复点击
     * @param {boolean} needInterceptor
     */
    HttpService.prototype.setInterceptor = function (needInterceptor) {
        this.needInterceptor = needInterceptor;
    };
    /**
     * @function 设置校验参数需删除的参数名
     * @param {string} deleteKeyName
     */
    HttpService.prototype.setDeleteKeyName = function (deleteKeyName) {
        this.deleteKeyName = deleteKeyName;
    };
    /**
     * @function 设置切换域名列表
     * @param {string | Array<string>} site
     */
    HttpService.prototype.setRequerySite = function (site) {
        if (Array.isArray(site)) {
            this.requerySite = site;
        }
        else {
            this.requerySite = [site];
        }
    };
    HttpService.prototype.setSwitchGateway = function (switchGateway) {
        this.switchGateway = switchGateway;
    };
    /**
     * @func 创建请求
     * @param {object} reqOptions 请求参数
     */
    HttpService.prototype.request = function (reqOptions) {
        var _this = this;
        var reqData = this.customHandleParams && typeof this.customHandleParams === 'function'
            ? this.customHandleParams(reqOptions.data, this.signParams, reqOptions)
            : this.handleParams(reqOptions.data, reqOptions.url, reqOptions);
        this.setDefaultHeader(reqOptions.formatType || '');
        return new Promise(function (resolve, reject) {
            var requestName = getRequestName(reqOptions, reqData);
            if (_this.needInterceptor && _this.requestCancelMap[requestName]) {
                console.error('重复请求，请稍候重试');
                reject({
                    errCode: REPEAT_REQUEST,
                    errMsg: '重复请求，请稍候重试'
                });
            }
            else {
                _this.needInterceptor && (_this.requestCancelMap[requestName] = true);
                _this.getData(reqOptions, reqData, { retryTimes: reqOptions.retryTimes || 1 }, resolve, reject);
            }
        });
    };
    HttpService.prototype._request = function (reqOptions, reqData, context, resolve, reject) { }; // 请求
    /**
     * @func 获取数据
     * @param {object} reqOptions 请求参数 {object} reqData 处理之后的参数, {number} retryTimes 重试次数, {promise.resolve} resolve, {promise.reject} reject headers 请求方式 url 接口地址
     */
    HttpService.prototype.getData = function (reqOptions, reqData, context, resolve, reject) {
        --context.retryTimes;
        this._request(reqOptions, reqData, context, resolve, reject);
    };
    /**
     * @func 请求成功回调函数
     * @param {object} result 返回数据 {object} reqOptions 请求参数 {object} reqData 处理之后的参数, {number} retryTimes 重试次数, {promise.resolve} resolve, {promise.reject} reject
     */
    HttpService.prototype.successFn = function (result, reqOptions, reqData, context, resolve, reject) {
        var retryTimes = context.retryTimes, baseUrl = context.baseUrl;
        var useTimes = (reqOptions.retryTimes || 1) - retryTimes; // 请求次数
        var isSuccess = this.customJudgeSuccess && isFunction(this.customJudgeSuccess)
            ? this.customJudgeSuccess(result)
            : result.success || result.code === '00000';
        if (isSuccess) {
            resolve(reqOptions.returnRawData ? result : result.data);
            this.clearInterceptor(reqOptions, reqData);
            handleCustomFn(this.customSuccessHandle, result, reqData, reqOptions, { baseUrl: baseUrl, useTimes: useTimes });
            handleCustomFn(this.customFinallyHandle, result, reqData, reqOptions, { baseUrl: baseUrl, useTimes: useTimes });
        }
        else {
            if (retryTimes > 0) {
                this.getData(reqOptions, reqData, context, resolve, reject);
            }
            else {
                this.clearInterceptor(reqOptions, reqData);
                handleCustomFn(this.customErrorHandle, result, reqData, reqOptions, {
                    baseUrl: baseUrl,
                    useTimes: useTimes,
                    errorStatus: ErrorType.status
                });
                handleCustomFn(this.customFinallyHandle, result, reqData, reqOptions, {
                    baseUrl: baseUrl,
                    useTimes: useTimes,
                    errorStatus: ErrorType.status
                });
                reject(result);
            }
        }
    };
    /**
     * @func 请求失败回调函数
     * @param {object} error 错误信息 {object} reqOptions 请求参数 {object} reqData 处理之后的参数, {number} retryTimes 重试次数, {promise.resolve} resolve, {promise.reject} reject
     */
    HttpService.prototype.errorFn = function (error, reqOptions, reqData, context, resolve, reject) {
        this.failTimes++;
        var retryTimes = context.retryTimes, baseUrl = context.baseUrl;
        var useTimes = (reqOptions.retryTimes || 1) - retryTimes; // 请求次数
        if (retryTimes > 0) {
            this.getData(reqOptions, reqData, context, resolve, reject);
        }
        else {
            this.clearInterceptor(reqOptions, reqData);
            handleCustomFn(this.customErrorHandle, error, reqData, reqOptions, {
                baseUrl: baseUrl,
                useTimes: useTimes,
                errorStatus: ErrorType.reject
            });
            handleCustomFn(this.customFinallyHandle, error, reqData, reqOptions, {
                baseUrl: baseUrl,
                useTimes: useTimes,
                errorStatus: ErrorType.reject
            });
            reject(error);
        }
    };
    /**
     * @func 服务端签名
     * @param {object} options 请求参数
     */
    HttpService.prototype.handleParams = function (obj, method, reqOptions) {
        // mock 默认是json请求
        if (reqOptions.isMock && !reqOptions.formatType) {
            reqOptions.formatType = 'json';
        }
        if (reqOptions.sendRawData || reqOptions.isMock) {
            switch (reqOptions.formatType) {
                case 'json':
                    return obj;
                case 'formdata':
                    this.defaultHeader = FORMAT_TYPE.formdata;
                    var formData_1 = new FormData();
                    Object.keys(obj).forEach(function (key) {
                        if (key === 'files') {
                            obj[key].forEach(function (i) {
                                formData_1.append('files', i);
                            });
                        }
                        else if (obj[key] != null) {
                            formData_1.append(key, obj[key]);
                        }
                    });
                    return formData_1;
                case 'urlencoded':
                    this.defaultHeader = FORMAT_TYPE.urlencoded;
                    return qs.stringify(obj);
                default:
                    this.defaultHeader = FORMAT_TYPE.urlencoded;
                    return qs.stringify(obj);
            }
        }
        else {
            var params = __assign(__assign({}, this.signParams), { method: method });
            params.content = typeof obj === 'string' ? obj : JSON.stringify(obj || {});
            params = sortArrayObj(Object.entries(params), 0).reduce(function (acc, cur) {
                acc[cur[0]] = cur[1];
                return acc;
            }, {});
            var body = JSON.stringify(params).replace(/\\/g, ''); // 加密的时候需要去掉反斜杠
            params.sign = md5(body);
            if (this.deleteKeyName) {
                delete params[this.deleteKeyName];
            }
            return qs.stringify(params);
        }
    };
    /**
     * @func 设置当前url地址 如果需切换url 重试请求时自动切换
     * @parmas reqOptions 请求参数 retryTimes 当前重试剩余次数 requerySite 重试需切换的基本地址
     */
    HttpService.prototype.getCurrentUrl = function (reqOptions) {
        var _a = this, switchGateway = _a.switchGateway, mockUrl = _a.mockUrl, requerySite = _a.requerySite, failTimes = _a.failTimes;
        var sendRawData = reqOptions.sendRawData, baseUrl = reqOptions.baseUrl, isMock = reqOptions.isMock, _b = reqOptions.baseUrlSuffix, baseUrlSuffix = _b === void 0 ? '' : _b;
        var url = '';
        if (switchGateway && reqOptions.switchGateway !== false) {
            var requeryAllSite = Array.from(new Set(__spreadArray([baseUrl], requerySite, true)));
            // 接口异常情况切换域名
            if (requeryAllSite.length > 1) {
                baseUrl = requeryAllSite[failTimes % requeryAllSite.length];
            }
        }
        if (isMock) {
            url = mockUrl + baseUrlSuffix + reqOptions.url;
        }
        else if (sendRawData) {
            url = baseUrl + baseUrlSuffix + reqOptions.url;
        }
        else {
            url = baseUrl + baseUrlSuffix;
        }
        return url;
    };
    return HttpService;
}());

/**
 * 获取跨平台的 SDK
 */
var getSDK = function () {
    var currentSdk = {
        // tslint:disable-next-line: no-empty
        request: function (_a) { },
        // // tslint:disable-next-line: no-empty
        httpRequest: function () { },
        // tslint:disable-next-line: no-empty
        getSystemInfoSync: function () { }
    };
    if (typeof wx === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = wx;
    }
    // else if (typeof dd === 'object') {
    //     // dd 必须出现在 my之前，因为现在dd环境里也有my
    //     // tslint:disable-next-line: no-unsafe-any
    //     currentSdk = dd
    // }
    else if (typeof my === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = my;
    }
    else if (typeof tt === 'object') {
        // tslint:disable-next-line: no-unsafe-any
        currentSdk = tt;
    }
    // else if (typeof qq === 'object') {
    //     // tslint:disable-next-line: no-unsafe-any
    //     currentSdk = qq
    // }
    // else if (typeof swan === 'object') {
    //     // tslint:disable-next-line: no-unsafe-any
    //     currentSdk = swan
    // }
    else {
        throw new Error('Current platform is not supported by SLS web track, Pleace contack Aliyun SLS team.');
    }
    return currentSdk;
};
var sdk = getSDK();
var MiniHttpService = /** @class */ (function (_super) {
    __extends(MiniHttpService, _super);
    function MiniHttpService(signParams) {
        return _super.call(this, signParams) || this;
    }
    MiniHttpService.prototype._request = function (reqOptions, reqData, context, resolve, reject) {
        var _this = this;
        var baseUrl = this.getCurrentUrl(reqOptions);
        var timeout = reqOptions.timeout || this.timeout;
        var headers = getHeader(reqOptions.header, this.defaultHeader);
        context = __assign(__assign({}, context), { baseUrl: baseUrl });
        var requestData = {
            timeout: timeout,
            url: baseUrl,
            method: reqOptions.method || 'POST',
            data: reqData,
            dataType: reqOptions.dataType || 'json',
            success: function (response) {
                _this.successFn(response.data, reqOptions, reqData, context, resolve, reject);
            },
            fail: function (error) {
                _this.errorFn(error, reqOptions, reqData, context, resolve, reject);
            }
        };
        // 支付宝用headers
        if (typeof my === 'object') {
            requestData.headers = headers;
        }
        else {
            requestData.header = headers;
        }
        sdk.request(requestData);
    };
    return MiniHttpService;
}(HttpService));

export { MiniHttpService as default };
//# sourceMappingURL=index.es5.js.map
